<template>
  <div class="view-content">
    <div class="search-box">
      <el-form :model="search" :inline="true" ref="searchFrom" size="small">
        <el-form-item label="名称:" prop="searchName">
          <el-input v-model="search.searchName" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="结算月份:" prop="month">
          <el-date-picker
            v-model="search.month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" size="small"
            >搜索</el-button
          >
          <el-button @click="handleReset" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tools-box">
      <el-button
        type="primary"
        icon="el-icon-download"
        size="small"
        @click="handleExport"
        >导出</el-button
      >
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="600"
      size="small"
      :header-cell-style="{
        background: '#f5f5f5',
        color: '#000',
        fontWeight: 'bold',
        align: 'center',
      }"
    >
      <el-table-column
        prop="qrName"
        label="二维码名称"
        width="180"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="qrcodeNo"
        label="二维码编号"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单编号"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="payAmount"
        label="支付金额"
        width="150"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column prop="rate" label="分佣比例" align="center">
      </el-table-column>

      <el-table-column prop="commAmount" label="佣金金额" align="center">
      </el-table-column>
      <el-table-column prop="status" label="结算状态" align="center">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 0"> 待完成 </el-tag>
          <el-tag type="primary" v-if="scope.row.status == 1"> 已完成 </el-tag>
          <el-tag type="success" v-if="scope.row.status == 2"> 已取消 </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center">
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        prev-text="上一页"
        next-text="下一页"
        :current-page.sync="search.pageIndex"
        :page-size.sync="search.pageSize"
        :page-sizes="[10, 30, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  GetChSettlementDetailList,
  DownLoadChSettleDetail,
} from "@/api/order/index";
export default {
  name: "settlement",
  data() {
    return {
      search: {
        searchName: "",
        month: "",
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
    };
  },
  mounted() {
    let now = new Date();
    let year = now.getFullYear();
    let month = String(now.getMonth() + 1).padStart(2, "0");
    this.search.month = `${year}-${month}`;
    this.getTableData();
  },
  methods: {
    handleReset() {
      this.search = this.$options.data().search;
      this.getTableData();
    },
    handleSearch() {
      this.search.pageIndex = 1; // 搜索时重置页码
      this.getTableData();
    },
    handleSizeChange(val) {
      this.search.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      GetChSettlementDetailList(this.search).then((res) => {
        if (res.data.isSuccess) {
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
        }
      });
    },
    handleExport() {
      DownLoadChSettleDetail(this.search).then((res) => {
        if (res.data.isSuccess) {
          if (res.data.data) {
            this.$message.success(res.data.message);
            window.open(res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.img-box {
  width: 130px;
  height: 130px;
}
</style>
